import { useNavigate } from 'react-router-dom';

function FlowFooter() {
  const navigate = useNavigate();

  return (
    // <footer className="relative z-50 w-full bg-white border-t border-[#E2E8F0] shadow-sm">
    //   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4 md:py-5">
    //     <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-0">
    //       {/* Left: Terms and Privacy Links */}
    //       <div className="text-[10px] sm:text-xs text-[#64748B] flex items-center gap-2">
    //         <button
    //           onClick={() => navigate('/terms-and-conditions')}
    //           className="hover:underline hover:text-[#FF6B35] transition-colors cursor-pointer font-semibold"
    //         >
    //           Terms & Condition
    //         </button>
    //         <span className="text-[#CBD5E1]">|</span>
    //         <button
    //           onClick={() => navigate('/privacy-policy')}
    //           className="hover:underline hover:text-[#FF6B35] transition-colors cursor-pointer font-semibold"
    //         >
    //           Privacy Policy
    //         </button>
    //       </div>

    //       {/* Right: Contact Info */}
    //       <div className="text-xs sm:text-sm font-semibold text-[#1E293B]">
    //         Need help?{' '}
    //         <a
    //           href="tel:+919717007945"
    //           className="text-[#FF6B35] hover:text-[#E55A2B] transition-colors font-semibold"
    //         >
    //           Contact Us
    //         </a>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
      <></>    
  );
}

export default FlowFooter;

